import { gql } from "../../__generated__";
export const GET_STUDENTS_PAGE = gql(`
  query StudentsPage($query: String, $first: Int, $after: String, $origin:QueryOrigin!) {
      students(query: $query, first: $first, after: $after, origin:$origin) {
          pageInfo {
              hasNextPage
              hasPreviousPage
              startCursor
              endCursor
          }
          edges {
              cursor
              node {
                ... SelectedStudent_Student
              }
          }
          totalCount
      },
    location {
    customFields{
      id
      type
      name
        }
      totalStudents
      }
  }
`);